var Cart = Cart || {};

/**
 * カートの商品を取得
 *
 * @return Deferred
 */
Cart.getItem = function() {
  var defer = $.Deferred();
  var ajax = $.ajax({
    url: '/order/modify.json',
    method: 'GET',
    success: defer.resolve,
    error: defer.reject
  });

  return defer.promise();
};

/**
 * カートに商品を追加
 *
 * @param  object item
 * @return Deferred
 */
Cart.addItem = function(item) {
  var params = {
    id: item.id,
    option: item.selectedOption,
    quantity: item.qty,
    '_method': 'post',
  };

  var defer = $.Deferred();

  var ajax = $.ajax({
    url: '/order/modify.json',
    method: 'POST',
    data: params,
    success: defer.resolve,
    error: defer.reject
  });

  return defer.promise();
};

/**
 * 対象キーのカート商品を削除
 *
 * @param  string key
 * @return Deferred
 */
Cart.deleteItem = function(key, clearEmptyCart) {
  var items = vmCart.$get('items');
  var item = items[key];

  var params = {
    id: item.originData.id,
    option: item.originData.selectedOption,
    clearEmptyCart: clearEmptyCart ? 1 : 0,
    '_method': 'delete',
  };

  var defer = $.Deferred();

  var ajax = $.ajax({
    url: '/order/modify.json',
    method: 'POST',
    data: params,
    success: defer.resolve,
    error: defer.reject
  });

  return defer.promise();
};

/**
 * 事業所お届けサービスを判別するための文字列を返却
 *
 * @return String
 */
Cart.getServiceDeliveryOfficeSearchStr = '（事業所お届け）';

/**
 * 検索情報・指定店舗で検索・カート情報間条件の差異を確認
 */
Cart.getDiffCondition = function(storeId, isTakeout = false) {
  var params = {
    storeId: storeId,
    '_method': 'get',
    'isTakeout': isTakeout ? 1 : 0
  };

  var defer = $.Deferred();

  var ajax = $.ajax({
    url: '/order/compare-cart-conditions.json',
    method: 'GET',
    data: params,
    dataType:'json',
    cache: false,
    success: defer.resolve,
    error: defer.reject
  });

  return defer.promise();
}

/**
 * カートの全弁当数を取得
 */
Cart.getCartBentoTotalQuantity = function() {
    var defer = $.Deferred();
    var ajax = $.ajax({
        url: '/order/get-cart-bento-total-quantity.json',
        method: 'GET',
        dataType:'json',
        cache: false,
        success: defer.resolve,
        error: defer.reject
    });
    return defer.promise();
}

/**
 * 現在位置がCart Stepか判定
 */
Cart.isStaying = function() {
    var pathname = location.pathname;
    pathname = pathname.indexOf('/') !== 0 ? '/' + pathname : pathname;
    return pathname === '/cart' || pathname.indexOf('/cart/') === 0;
}
